export { CnSwitch } from '@cainiaofe/cn-ui';
